/* 開いたままのページも、SALE開始・終了時に価格表示を再取得する。 */
(() => {
  const elements = ['mhl-auto-sale-window'].map(id => document.getElementById(id)).filter(Boolean);
  elements.push(...document.querySelectorAll('[data-mhl-product-sale-window]'));
  let navigating = false;
  for (const element of elements) {
  let config;
  try { config = JSON.parse(element.textContent); } catch { continue; }
  const start = Date.parse(config.startsAt);
  const end = Date.parse(config.endsAt);
  const rendered = Date.parse(config.renderedAt);
  if (![start, end, rendered].every(Number.isFinite) || end <= start) continue;
  // Shopifyの描画時刻を基準にし、端末時計の進み・遅れで再読込を繰り返さない。
  const loadedAt = performance.now();
  const phaseAt = time => time < start ? 'upcoming' : time < end ? 'active' : 'ended';
  let timer;
  const check = () => {
    clearTimeout(timer);
    if (navigating) return;
    const now = rendered + performance.now() - loadedAt;
    if (phaseAt(now) !== phaseAt(rendered)) {
      const url = new URL(window.location.href);
      url.searchParams.set('_sale_refresh', String(now));
      navigating = true;
      window.location.replace(url.href);
      return;
    }
    const nextBoundary = now < start ? start : now < end ? end : null;
    if (nextBoundary !== null) timer = setTimeout(check, Math.min(nextBoundary - now + 100, 2147483647));
  };
  window.addEventListener('pageshow', check);
  window.addEventListener('focus', check);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
  check();
  }
})();
